import { render, staticRenderFns } from "./RecordedDetailMoreButton.vue?vue&type=template&id=2a507478&"
import script from "./RecordedDetailMoreButton.vue?vue&type=script&lang=ts&"
export * from "./RecordedDetailMoreButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports